import { Bus } from './bus';
export class Passenger {
  id: number;
  // clientId: number;
  schoolId: number;
  busId: number;
  Bus: Bus;
  lastname: string;
  count: number;
  firstnames: string;
  registrationNumbers: String;
  phone: string;
  subscription: string;
  lat: number;
  lng: number;
  isPositionValide: boolean;
  activationKey: string;
  estimatedDepartureTime: string;
  estimatedArrivalTime: string;
  opDepartureNotification: boolean;
  departureSign: boolean;
  opArrivalNotification: boolean;
  ArrivalSign: boolean;
  opDistanceNotification: boolean;
  opDistanceValue: number;
  proximitySign: boolean;
  opJITNotification: boolean;
  JITSign: boolean;
  hourWeekHistory: string;
  mobileToken: string;
  appVersion: string;
  androidVersion: string;
  connectionCounter: number;
  lastConnection: string;
  activityReport: string;
  address: string;
  JourneyPassengers: any[];
  // client
  // bus
  // passengerAutoNotifs
  am1Start: string;
  am1End: string;
  am2Start: string;
  am2End: string;
  pm1Start: string;
  pm1End: string;
  pm2Start: string;
  pm2End: string;
  isAssistant: boolean;
  SmsToSend: number;
  expirationDate: string;
  isActive: boolean;
  isReserved: boolean;
  inscriptionDate: string;
  inscriptionStatus: string;
  inscriptionType: string;

  constructor() {
    // this.clientId = null;
    this.busId = null;
    this.phone = '06';
    this.address = '-';
    this.subscription = 'Aller/Retour';
    this.isPositionValide = false;
    this.opDepartureNotification = false;
    // this.departureSign = false;
    this.opArrivalNotification = false;
    // this.ArrivalSign = false;
    this.opDistanceNotification = true;
    this.opDistanceValue = 70;
    // this.proximitySign = false;
    this.opJITNotification = true;
    this.isAssistant = false;
    this.androidVersion = '';
    this.firstnames = '';
    // this.JITSign = false;
    this.SmsToSend = 1;
    this.registrationNumbers = '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/models/passenger.ts